import { render } from "./motion-template-buttons.vue?vue&type=template&id=e2ac400a"
import script from "./motion-template-buttons.vue?vue&type=script&lang=js"
export * from "./motion-template-buttons.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__